/**
 * Remove old Gatsby Offline service workers to avoid stale app-shell/CSS mismatches
 * after deployments.
 */
export const onClientEntry = () => {
  if (!('serviceWorker' in navigator)) {
    return;
  }

  navigator.serviceWorker.getRegistrations().then(registrations => {
    registrations.forEach(registration => registration.unregister());
  });
};
